<template>
    <div class="wrapper">
        <v-head></v-head>
        <v-sidebar></v-sidebar>
        <div class="content-box" :class="{'content-collapse':collapse}">
            <v-tags></v-tags>
            <div class="content">
                <transition name="move" mode="out-in">
<!--                    <keep-alive :include="tagsList">-->
                        <router-view></router-view>
<!--                    </keep-alive>-->
                </transition>
                <el-backtop target=".content"></el-backtop>
            </div>
        </div>
    </div>
</template>

<script>
import vHead from './Header.vue';
import vSidebar from './Sidebar.vue';
import vTags from './Tags.vue';
import bus from './bus';
export default {
    data() {
        return {
            tagsList: [],
            collapse: false
        };
    },
    components: {
        vHead,
        vSidebar,
        vTags
    },
    created() {
		this.is_login()
        bus.$on('collapse-content', msg => {
            this.collapse = msg;
        });

        // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
        bus.$on('tags', msg => {
            let arr = [];
            for (let i = 0, len = msg.length; i < len; i++) {
                msg[i].name && arr.push(msg[i].name);
            }
            this.tagsList = arr;
        });
    },
	methods:{
		is_login(){
			//判断是否已经登录，如果未登录则跳转到登录页，如果已经登录则跳转到首页
			let my_token = localStorage.getItem('my_token')
			//这里的话,字符串是否为空的判断不算最严谨的，后期如果有时间需要优化一下。
			if(my_token==null || my_token==''){
			    //跳转到登录页面
			    this.$router.push('/login')
			}else{
			    //判断token是否已经过期，如果过期则跳转到登录页面
			    let valid_time = localStorage.getItem('valid_end_time')
			    var end_time = new Date(valid_time);
			    var now = new Date()
			    if(now.getTime() >= end_time.getTime()){
			        //跳转到登录页面
			        this.$router.push('/login')
			        // this.$message.warning('token过期，请重新登录！');
			    }
			}
		}
	}
};
</script>
